import {
    FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_BEGIN, FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_SUCCESS,
    FETCH_PROMO_VIDEO_FOLDERS_BEGIN,
    FETCH_PROMO_VIDEO_FOLDERS_SUCCESS
} from "../actions/promoVideoActions";

const defaultPromoVideoFolders = {
    promoVideoFolders: [],
    loading: false,
};

const defaultPromoVideoAmountInCompanies = {
    promoVideoAmountInCompanies: [],
    loading: false,
}

export const promoVideoFoldersReducer = (state = defaultPromoVideoFolders, action) => {
    switch (action.type) {
        case FETCH_PROMO_VIDEO_FOLDERS_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROMO_VIDEO_FOLDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                promoVideoFolders: action.promoVideoFolders
            };

        default:
            return state;
    }
};

export const promoVideoAmountInCompaniesReducer = (state = defaultPromoVideoAmountInCompanies, action) => {
    switch (action.type) {
        case FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_SUCCESS:
            return {
                ...state,
                loading: false,
                promoVideoAmountInCompanies: action.promoVideoAmountInCompanies
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/promoVideo.js